// extracted by mini-css-extract-plugin
export default {"strip":"tYUpTX","root":"IYhJN5","icon":"wlRpKB","title":"wXAaGE","bold":"XTurVC"};